// Constants
import { DEBUG_TOOL_UPDATE } from './debugToolConstants';

export const updateDebugTool = ({ toolName, ...rest }) => ({
    type: DEBUG_TOOL_UPDATE,
    toolName,
    ...rest,
});
